import config from "config.ts";

const loader = `${config.api.resource}/assets/images/preloader.gif`;

export default loader;
